const dataBodyScroll = function () {
  const el = event.target || event.srcElement;
  let xl = el.previousSibling;
  while (xl.nodeType != 1) xl = xl.previousSibling
  xl.scrollLeft = el.scrollLeft;
};

const getBasePanelWidth = function () {
  //if (!$.fuiBasePanelWidth) $.fuiBasePanelWidth = $($.fuiBasePanel || document.getElementById("fuiContent")).width()
  //return $.fuiBasePanelWidth
  return this.$baseWidth
}

const baseWidth = 1024

const initListPanelHeight = function (basePanel) {
  if (!basePanel) basePanel = $.fuiBasePanel || document.getElementById("fuiContent");
  basePanel = $(basePanel)
  const pp = basePanel.children(".param-panel:first").find(".param-list:first")
  pp.css("min-height", pp.height())
  alert(pp.height())
  //const pg = basePanel.children(".pager-panel:first")
  //const lp = basePanel.children(".list-panel:first")
  //$.fuiBasePanelWidth = basePanel.width()
  //lp.css("top", pp.height() + pg.height())
}


//$(window).on("resize.fui.page", function(){
//  const InitListPanelHeight();
//})
export default {
  //dataBodyScroll,
  getBasePanelWidth,
  baseWidth,
  initListPanelHeight
}